@if (isLoading()) {
	<div class="w-100 vh-100">
		<app-custom-mat-loader></app-custom-mat-loader>
	</div>
} @else {
	<form class="container py-4" [formGroup]="form()">
		<div class="d-flex justify-content-start align-items-center mb-3">
			<mat-form-field subscriptSizing="dynamic" class="w-25 d-flex justify-content-center align-items-center">
				<textarea
					formControlName="travelOrganizationGovernmentApproval"
					matInput
					placeholder="Zezwolenie marszałlka"
				></textarea>
			</mat-form-field>

			<button
				mat-raised-button
				class="d-flex justify-content-center align-items-center ms-3"
				color="primary"
				(click)="updateTravelOrganizationGovernmentApproval()"
			>
				Zapisz
			</button>
		</div>

		<div class="d-flex justify-content-start align-items-center">
			<mat-form-field subscriptSizing="dynamic" class="w-25 d-flex justify-content-center align-items-center">
				<mat-label>Wybierz ubezpieczyciela</mat-label>
				<mat-select formControlName="insurerToAdd" required>
					@for (insurer of filteredInsurersList(); track insurer.id) {
						<mat-option [value]="insurer">{{ insurer.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<button
				mat-raised-button
				class="d-flex justify-content-center align-items-center ms-3"
				color="primary"
				(click)="addInsurer()"
			>
				Dodaj
			</button>
		</div>

		<h4 class="my-3">Ubezpieczyciele</h4>

		@if (!insurersFormArray().controls.length) {
			<div class="bg-light p-3 d-flex justify-content-center align-items-center fs-5 rounded-2">
				Brak dodanych ubezpieczycieli!
			</div>
		} @else {
			<mat-accordion>
				@for (insurerGroup of insurersFormArray().controls; let i = $index; track i) {
					<mat-expansion-panel [formGroup]="insurerGroup">
						<mat-expansion-panel-header>
							<mat-panel-title>
								{{ insurerGroup.get('insurer')?.value?.name }}
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div class="w-100 d-flex justify-content-end">
							<button mat-raised-button color="accent" (click)="save(insurerGroup)">Zapisz</button>
						</div>

						<mat-panel-description>
							<div class="row g-4">
								<div class="col-12">
									<label class="form-label">Podsumowanie rezerwacji</label>
									<ckeditor
										class="insurer-editor"
										[editor]="editor"
										[config]="editorConfig"
										formControlName="reservationSummary"
									></ckeditor>
								</div>

								<div class="col-12">
									<label class="form-label">Uwagi</label>
									<ckeditor
										class="insurer-editor"
										[editor]="editor"
										[config]="editorConfig"
										formControlName="inComments"
									></ckeditor>
								</div>

								<div class="col-12">
									<label class="form-label"
										>Ogólne warunki uczestnictwa, przed sekcją z ubezpieczeniem</label
									>
									<ckeditor
										class="insurer-editor"
										[editor]="editor"
										[config]="editorConfig"
										formControlName="beforeInsuranceSection"
									></ckeditor>
								</div>

								<div class="col-12">
									<label class="form-label"
										>Ogólne warunki uczestnictwa, sekcja z ubezpieczeniem</label
									>
									<ckeditor
										class="insurer-editor"
										[editor]="editor"
										[config]="editorConfig"
										formControlName="insuranceSection"
									></ckeditor>
								</div>

								<div class="col-12">
									<label class="form-label"
										>Ogólne warunki uczestnictwa, po sekcji z ubezpieczeniem</label
									>
									<ckeditor
										class="insurer-editor"
										[editor]="editor"
										[config]="editorConfig"
										formControlName="afterInsuranceSection"
									></ckeditor>
								</div>

								@if (insurersFormArray().controls[i].get('insurer')?.value.insuredListHeaders.length) {
									<hr />

									<div class="col-12">
										<div formGroupName="insuredListConst">
											<div class="row">
												@for (
													header of insurersFormArray().controls[i].get('insurer')?.value
														.insuredListHeaders;
													track $index
												) {
													<div class="col-md-6 mb-2">
														<mat-form-field class="w-100">
															<mat-label>{{ header }}</mat-label>
															<input [formControlName]="header" matInput />
														</mat-form-field>
													</div>
												}
											</div>
										</div>
									</div>
								}
							</div>
						</mat-panel-description>
					</mat-expansion-panel>
				}
			</mat-accordion>
		}
	</form>
}
